'use strict';

const $ = require('jquery');
const _ = require('underscore');
const Moment = require('moment');
const Firebase = require('common/infra/firebase/index');
const Logger = require('common/util/logger');

class Messenger {
    constructor() {
        this._toListenGroups = [];
        this._toListenProjects = [];
        this._initialized = false;
    }

    initialize(channel, user, clientID, appInfo) {
        const FirebaseConfig = require('config/firebase/' + appInfo.getAppEnv());
        Firebase.initialize(FirebaseConfig, user);

        this._channel = channel;
        this._env = appInfo.getFirebaseEnv();
        this._appInfo = appInfo;
        this._clientID = clientID;
        this._listenedGroups = [];
        this._listenedProjects = [];

        if(user) {
            this._listenUser(user.id);
        }

        this._initialized = true;

        _.each(this._toListenGroups, groupID => {
            this._listenGroup(groupID, user.id);
        });
        _.each(this._toListenProjects, projectID => {
            this._listenProject(projectID, user.id);
        });
        Logger.info('FirebaseMessenger initialized.');
    }

    _listenGroup(groupID, userID) {
        if (!this._initialized) {
            this._toListenGroups.push(groupID);
            return;
        }

        if (_.contains(this._listenedGroups, groupID)) {
            return;
        }

        Firebase.listenOrderByKey(`/${this._env}/groupUpdates/${groupID}`, (data) => {
            if(!data) {
                return;
            }
            if(data.clientID == this._clientID) {
                return;
            }

            Logger.info('FirebaseMessenger._listenGroup', data);
            let context = data.context;
            if(context) {
                context = {
                    groupId: context.groupID,
                    projectId: context.projectID,
                    diagramId: context.diagramID,
                    actionId: context.actionID,
                    userId: userID,
                    dt: null
                };
            }

            this._channel.trigger(`msg:${data.event}`, data.contents, context);
        }, {
            startAt: Moment().unix().toString()
        });

        this._listenedGroups.push(groupID);

    }

    _listenProject(projectID, userID) {
        if(!this._initialized) {
            this._toListenProjects.push(projectID);
            return;
        }

        if(_.contains(this._listenedProjects, projectID)) {
            return;
        }

        Firebase.listenOrderByKey(`/${this._env}/projectUpdates/${projectID}`, (data) => {
            if(!data) {
                return;
            }
            if(data.clientID == this._clientID) {
                return;
            }

            Logger.info('FirebaseMessenger._listenProject', data);
            let context = data.context;
            if(context) {
                context = {
                    projectId: context.projectID,
                    diagramId: context.diagramID,
                    actionId: context.actionID,
                    commentId: context.commentID,
                    userId: userID,
                    dt: null
                };
            }

            this._channel.trigger(`msg:${data.event}`, data.contents, context);
        }, {
            startAt: Moment().unix().toString()
        });

        this._listenedProjects.push(projectID);
    }

    _listenUser(userID) {
        let id = userID;
        if(this._appInfo.isLocalhost()) {
            id = `${this._appInfo.getFirebaseEnv()}:${id}`
        }

        Firebase.listenOrderByKey(`/${this._env}/userUpdates/${id}`, (data) => {
            if(!data) {
                return;
            }

            Logger.info('FirebaseMessenger._listenUser', data);
            let context = data.context;
            if(context) {
                context = {
                    projectId: context.projectID,
                    diagramId: context.diagramID,
                    actionId: context.actionID,
                    dt: null
                };
            }

            this._channel.trigger(`msg:${data.event}`, data.contents, context);
        }, {
            startAt: Moment().unix().toString()
        });
    }

    onGroup(groupID) {
        this._listenGroup(groupID);
    }

    onProject(projectID) {
        this._listenProject(projectID);
    }

    onDiagram(projectID, diagramID) {
        this._listenProject(projectID);
    }

    onAction(projectID, actionID) {
        this._listenProject(projectID);
    }

    onContent(projectID, contentID) {
        this._listenProject(projectID);
    }

    onElse() {
    }
}

module.exports = Messenger;



// WEBPACK FOOTER //
// ./balus/domain/service/firebase-messenger.js